angular
	.module 'App.Repository'
	.factory 'InvoiceRepository', ['BaseRepository', (BaseRepository) ->
		class InvoiceRepository extends BaseRepository
			@resource = '/invoices'
			@isRestricted = true

		return new InvoiceRepository
	]
